(ns com.theplantscape.plant-web.components.tailwind.menus
  (:require [reagent.core :as r]))

(defn menu-popup [title links]
  (let [show (r/atom false)]
    (fn []
      [:div.relative.inline-block.text-left
       [:div {:on-click #(swap! show not)}
        [:button#menu-button.inline-flex.justify-center.w-full.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-sm.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-offset-gray-100.focus:ring-indigo-500
         {:type "button" :aria-expanded "true" :aria-haspopup "true"} title
         [:svg.-mr-1.ml-2.h-5.w-5 {:xmlns "http://www.w3.org/2000/svg" :viewBox "0 0 20 20" :fill "currentColor" :aria-hidden "true"}
          [:path {:fill-rule "evenodd" :d "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" :clip-rule "evenodd"}]]]]
       (when @show
         [:div.z-10.origin-top-right.absolute.right-0.mt-2.w-56.rounded-md.shadow-lg.bg-white.ring-1.ring-black.ring-opacity-5.focus:outline-none
          {:role "menu" :aria-orientation "vertical" :aria-labelledby "menu-button" :tabIndex "-1"}
          (into [:div.py-1 {:role "none"}]
                (mapv (fn [link] [:a#menu-item-0.text-gray-700.block.px-4.py-2.text-sm
                                  {:on-click #(swap! show not)
                                   :href (:href link) :role "menuitem" :tabIndex "-1"}
                                  (:title link)])
                      links))])])))
